

import React, { useEffect } from 'react'
import Event from './eventImg/event-13-dec.webp'


const Event23 = () => {
    useEffect(() => {
        document.title = "Pharma Connect with HVAC&R";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>13 December 2025</h1>
        <h3 className='text-center'>Pharma Connect with HVAC&R</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='Pharma Connect with HVAC&R'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/APLN1KcYxWc=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event23




